import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import envConstants from "../Constants";
import axios from "../Axiosapi";  // Assuming axios is already set up

const FolderDetails = () => {
    const { folderName } = useParams();  // Get the folderName from the URL
    const [urls, setUrls] = useState([]);  // State to store the URLs for the selected folder
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSitemap = async () => {
            try {
                const response = await axios.get(`${envConstants.API_BASE_URL}/sitemap-map`);  // Fetch sitemap data
                const data = response.data;  // Assuming the response is structured with Product, Category, etc.

                // Classify the URLs based on folderName
                const folderUrls = classifyUrls(data, folderName);  // Pass 'data' here
                setUrls(folderUrls);
            } catch (error) {
                setError(error);
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchSitemap();  // Fetch sitemap data on component mount
    }, [folderName]);

    // Classify URLs based on the folder name (product, category, etc.)
    const classifyUrls = (data, folderName) => {
        const folderStructure = {
            product: [],
            category: [],
            brand: [],
            child_category: [],
            blogs: [],
            other: [],
        };

        // Classifying URLs into respective categories based on the response data
        if (data.Product) {
            data.Product.forEach(item =>
                folderStructure.product.push({
                    loc: `product/${encodeURIComponent(item.url)}`,
                    lastmod: item.lastModified
                })
            );
        }
        if (data.Category) {
            data.Category.forEach(item => folderStructure.category.push({ loc: item.url, lastmod: item.lastModified }));
        }
        if (data['Child Categories']) {
            data['Child Categories'].forEach(item => folderStructure.child_category.push({ loc: item.url, lastmod: item.lastModified }));
        }
        if (data.Brand) {
            data.Brand.forEach(item => folderStructure.brand.push({ loc: item.url, lastmod: item.lastModified }));
        }
        if (data.Blogs) {
            data.Blogs.forEach(item => folderStructure.blogs.push({ loc: item.url, lastmod: item.lastModified }));  // Fixed: Use 'blog' instead of 'Blogs'
        }
        if (data['Other Pages']) {
            data['Other Pages'].forEach(item => folderStructure.other.push({ loc: item.url, lastmod: item.lastModified }));
        }

        // Return the URLs for the current folder based on the folderName
        switch (folderName) {
            case 'product-sitemap':
                return folderStructure.product;
            case 'category-sitemap':
                return folderStructure.category;
            case 'child-category-sitemap':
                return folderStructure.child_category;
            case 'brand-sitemap':
                return folderStructure.brand;
            case 'blogs-sitemap':
                return folderStructure.blogs;
            case 'other-sitemap':
                return folderStructure.other;
            default:
                return [];
        }
    };

    if (loading) {
        return <div className='container p-4'>Loading sitemap...</div>;
    }

    if (error) {
        return <div className='container p-4 text-danger'>Error: {error.message}</div>;
    }

    return (
        <div className='container-fluid p-4'>
            <div className='d-flex justify-content-between align-items-center mb-4'>
                <h2 style={{ color: '#ed1c24', fontSize: '24px' }}>{folderName.replace('_', ' ').toUpperCase()} Sitemap</h2>
                <Link to="/sitemap.xml" className='btn btn-secondary'>
                    Back to Sitemap
                </Link>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div className='card'>
                        <div className='card-header d-flex justify-content-between'>
                            <span>Total URLs: {urls.length}</span>
                            <small>Click on a URL to open</small>
                        </div>
                        <ul className='list-group list-group-flush'>
                            {urls.map((url, index) => (
                                <li key={index} className='list-group-item d-flex justify-content-between align-items-center'>
                                    {/* Directly use the prepended URL with /product */}
                                    <a href={`${envConstants.FRONTEND_URL}${url.loc}`} target="_blank" rel="noopener noreferrer" className='text-truncate' style={{ maxWidth: '80%' }}>
                                        {envConstants.FRONTEND_URL}{url.loc}
                                    </a>
                                    <small className='text-muted'>{url.lastmod}</small>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FolderDetails;
